import router from '@/router'
import { authServices } from '../services/auth'

export const actions = {
    setLoading ({commit}, payload) {
        commit('setLoading', payload)
    },

    async userSignIn ({commit}, payload) {
        commit('setLoading', true)

        try {
            const res = await authServices.signIn(payload.username, payload.password)

            if (res.result === 'success') {
                // sign user in
                commit('setUser', payload)
                
                commit('setLoading', false)
                commit('setError', null)

                // send user to homepage
                router.push('/home')
            } else {
                commit('setError', 'auth')
            }

        } catch (e) {
            console.log(e)
        }
    },

    // auto sign in applies when user refresh page (session valid)
    // Vuex validates with server and get user profile back if this sessionId is valid
    /*
    async autoSignIn ({commit}) {
        commit('setLoading', true)

        try {
            const res = await authServices.validateSessionId()
            const user = res.result === 'success' ? res.user : null

            commit('setuser', user)
            commit('setLoading', false)
            commit('setError', false)

        } catch (e) {
            console.log(e)
        }
    },
    */
    async userSignOut ({commit}) {
        commit('setLoading', true)

        try {
            await authServices.signOut()

            // reset state
            commit('setUser', null)
            commit('examinations/resetExaminations')
            router.push('/')
            
        } catch (e) {
            console.log(e)
        }
    }


}